import React from "react";
import {
  Button,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { GameModes } from "../../data/gameModes";

const ResultScreen = ({
  gameResults,
  currentScore,
  currentGameMode,
  goBack,
  speakWord,
}) => {
  const getResultMessage = () => {
    if (
      currentGameMode !== GameModes.TIME_CHALLENGE.name &&
      currentScore === 10
    ) {
      return "🌟 完美！你很棒！ 🌟";
    } else if (
      currentGameMode !== GameModes.TIME_CHALLENGE.name &&
      currentScore >= 8
    ) {
      return "🎉 非常好！再加油！ 🎉";
    } else if (
      currentGameMode !== GameModes.TIME_CHALLENGE.name &&
      currentScore >= 6
    ) {
      return "👍 不錯！繼續練習吧！ 👍";
    } else if (
      currentGameMode !== GameModes.TIME_CHALLENGE.name &&
      currentScore >= 4
    ) {
      return "💪 加油！再玩一次吧！ 💪";
    } else if (currentGameMode !== GameModes.TIME_CHALLENGE.name) {
      return "📚 繼續學習，你可以的！ 📚";
    } else {
      return "時間到！看看你的成績！";
    }
  };

  return (
    <Box id="resultScreen" className="screen" sx={{ p: 2 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        遊戲結果
      </Typography>
      <Typography variant="h5" id="finalScore" sx={{ mb: 2 }}>
        {currentGameMode === GameModes.TIME_CHALLENGE.name
          ? `得分: ${currentScore}`
          : `${currentScore} / 10`}
      </Typography>
      <Typography variant="h6" id="resultMessage" sx={{ mb: 3 }}>
        {getResultMessage()}
      </Typography>
      <Grid container spacing={2} id="resultCardsGrid">
        {gameResults.map((result, index) => {
          let questionDisplay = "";
          let correctAnswerDisplay = "";
          let selectedAnswerDisplay =
            result.selectedAnswer.english || result.selectedAnswer.chinese;

          const displayGameModeId = result.gameMode;

          if (displayGameModeId === GameModes.ENGLISH_TO_CHINESE.id) {
            questionDisplay = (
              <Typography variant="body1" className="result-question-text">
                {result.question.english}
              </Typography>
            );
            correctAnswerDisplay = (
              <Typography
                variant="body2"
                color="success.main"
                className="result-correct-answer-text"
              >
                {result.question.chinese}
              </Typography>
            );
          } else if (displayGameModeId === GameModes.CHINESE_TO_ENGLISH.id) {
            questionDisplay = (
              <Typography variant="body1" className="result-question-text">
                {result.question.chinese}
              </Typography>
            );
            correctAnswerDisplay = (
              <Typography
                variant="body2"
                color="success.main"
                className="result-correct-answer-text"
              >
                {result.question.english}
              </Typography>
            );
          } else if (displayGameModeId === GameModes.PICTURE_TO_WORD.id) {
            questionDisplay = (
              <Typography variant="h5" className="result-question-emoji">
                {result.question.emoji}
              </Typography>
            );
            correctAnswerDisplay = (
              <Typography
                variant="body2"
                color="success.main"
                className="result-correct-answer-text"
              >
                {result.question.english}
              </Typography>
            );
          } else if (displayGameModeId === GameModes.LISTEN_ENGLISH_WORD.id) {
            questionDisplay = (
              <Button
                variant="outlined"
                startIcon={<VolumeUpIcon />}
                onClick={() => speakWord(result.question.english)}
              >
                重播聲音
              </Button>
            );
            correctAnswerDisplay = (
              <Typography
                variant="body2"
                color="success.main"
                className="result-correct-answer-text"
              >
                {result.question.english}
              </Typography>
            );
          } else if (displayGameModeId === GameModes.LISTEN_CHINESE_WORD.id) {
            questionDisplay = (
              <Button
                variant="outlined"
                startIcon={<VolumeUpIcon />}
                onClick={() => speakWord(result.question.english)}
              >
                重播聲音
              </Button>
            );
            correctAnswerDisplay = (
              <Typography
                variant="body2"
                color="success.main"
                className="result-correct-answer-text"
              >
                {result.question.chinese}
              </Typography>
            );
          }

          return (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  border: `2px solid ${result.isCorrect ? "green" : "red"}`,
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <Typography variant="subtitle2">{index + 1}.</Typography>
                    <Typography
                      variant="body2"
                      color={result.isCorrect ? "success.main" : "error.main"}
                    >
                      {result.isCorrect ? (
                        <CheckCircleOutlineIcon />
                      ) : (
                        <HighlightOffIcon />
                      )}
                    </Typography>
                  </Box>
                  {questionDisplay}
                  {correctAnswerDisplay}
                  <Typography
                    variant="body2"
                    color={result.isCorrect ? "text.primary" : "error.main"}
                    sx={{ mt: 1 }}
                  >
                    你的答案: {selectedAnswerDisplay}
                  </Typography>
                  <Button
                    variant="text"
                    startIcon={<VolumeUpIcon />}
                    onClick={() => speakWord(result.question.english)}
                    sx={{ mt: 1 }}
                  >
                    播放
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
      <Button variant="contained" onClick={goBack} sx={{ mt: 3 }}>
        返回主目錄
      </Button>
    </Box>
  );
};

export default ResultScreen;
